import React from "react";

import Image from "../../../components/image";
import { ConditionalSwiper } from "../../../components/shared/conditionalSwiper";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import GalleryTeaser from "../../galleryTeaser";

const ProgramAccommodation = ({
  gallery,
  description,
  title,
  innerContainerClass = "summary-section justify-center w-11/12 pt-8 pb-5 sm:py-2 flex gap-10 flex-wrap sm:flex-nowrap sm:w-10/12 2xl:container 2xl:m-auto",
  outerContainerClass = "w-full bg-primary-bg mx-auto flex items-center justify-center relative overflow-hidden",
  innerContainerChildClass = "w-full md:sticky-left-section mr-auto md:!pr-4 border-t border-gray-generic dark:border-gray-standard dark:md:border-gray-light",
  titleContainer = "pt-10 md:pt-12 pb-5"
}) => {
  const breakpoint = useBreakpoint();
  if (gallery?.length < 1 && !title) {
    return <></>;
  }

  return (
    <>
      <section className={outerContainerClass}>
        <section className={innerContainerClass}>
          <div className={innerContainerChildClass}>
            <div className={titleContainer}>
              <h6
                className="font-light text-generic-text dark:font-bold text-xl md:text-xlrg-sm dark:!text-white"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            </div>

            {description && (
              <div
                className="pb-5 text-generic-text dark:text-gray-generic"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}

            {gallery && gallery?.length > 0 && (
              <div className="accomodation-gallery py-4 hidden sm:block">
                <div className={"relative py-8"}>
                  <GalleryTeaser
                    gallery={gallery}
                    containerClass={
                      "grid grid-cols-1 grid-rows-1 sm:grid-cols-3 sm:grid-rows-3 gap-3"
                    }
                    featureImageClass={"h-56 sm:h-101"}
                  />
                </div>
              </div>
            )}

            {gallery?.length > 0 && (
              <div className="grid gap-2 sm:gap-6 grid-cols-1 md:grid-cols-2 py-8 w-full sm:w-10/12 sm:hidden">
                <ConditionalSwiper
                  condition={breakpoint === "xs"}
                  slidesPerView={1.25}
                  spaceBetween={10}
                  centeredSlides={false}
                  className="h-full w-full"
                >
                  {gallery?.slice(0, 4).map((galleryItem, idx) => (
                    <div
                      key={`galleryitem-${idx}`}
                      className="rounded-md w-full h-48 sm:h-60 overflow-hidden shadow relative"
                    >
                      <Image
                        key={`gitem-${idx}`}
                        imageAlt={""}
                        image={galleryItem?.gatsbyImage}
                        imageClass={
                          "absolute top-0 bottom-0 left-0 right-0 h-full w-full object-cover"
                        }
                        sourceUrl={galleryItem?.sourceUrl}
                      />
                    </div>
                  ))}
                </ConditionalSwiper>
              </div>
            )}
          </div>
        </section>
      </section>
    </>
  );
};

export default ProgramAccommodation;
